/* @flow */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useOnScreen } from "../../utils/hooks";

import StyledImage from "./styled";

const placeholderImage =
  "data:image/png;base64,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";

type Props = {
  src?: any,
  alt: string,
  fallback?: any,
  lazy?: boolean
};

const Image = ({ src, alt, fallback, lazy = false }: Props) => {
  const ref = useRef();
  const isVisibile = useOnScreen(ref);
  const [image, setImage] = useState(src || placeholderImage);
  const [isLoading, setIsLoading] = useState(!!(src || placeholderImage));
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    const nextImage = src || fallback || placeholderImage;
    setImage(image => {
      if (image !== nextImage) {
        setHasLoaded(false);
        setIsLoading(true);
        return nextImage;
      }
      return image;
    });
  }, [src, fallback]);
  const handleError = useCallback(() => {
    setHasLoaded(false);
    setIsLoading(false);
    const fallbackImage = fallback || placeholderImage;
    if (fallbackImage !== image) {
      setImage(fallbackImage);
      setIsLoading(true);
    }
  }, [fallback, image]);
  const handleLoad = useCallback(() => {
    setHasLoaded(true);
    setIsLoading(false);
  }, []);
  return (
    <StyledImage.Container ref={ref}>
      <StyledImage.Image
        alt={alt}
        src={lazy && !isVisibile && !hasLoaded ? undefined : image}
        isLoading={isLoading}
        hasLoaded={hasLoaded}
        onError={handleError}
        onLoad={handleLoad}
      />
      {isLoading && <StyledImage.Spinner />}
    </StyledImage.Container>
  );
};

export default Image;
